import { render, staticRenderFns } from "./MIVB.vue?vue&type=template&id=435b4e28&"
import script from "./MIVB.vue?vue&type=script&lang=js&"
export * from "./MIVB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports